import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';
import { Filter, X } from 'lucide-react';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

export function MultiSelectDomainFilter({ domains = [], selectedDomains = [], onChange }) {
    const [open, setOpen] = useState(false);

    const toggleDomain = (domain) => {
        if (selectedDomains.includes(domain)) {
            // Remove from selection
            onChange(selectedDomains.filter(d => d !== domain));
        } else {
            // Append to the end of selection, preserving order
            onChange([...selectedDomains, domain]);
        }
    };

    const clearFilter = (e) => {
        e.stopPropagation();
        onChange([]);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button variant="outline" className="w-full sm:w-auto justify-between min-w-[220px]">
                    <div className="flex items-center gap-2 truncate">
                        <Filter className="h-4 w-4 text-muted-foreground" />
                        <span className="truncate">
                            {selectedDomains.length > 0
                                ? `${selectedDomains.length} Domain Dipilih`
                                : 'Filter Domain Spesifik...'}
                        </span>
                    </div>
                    {selectedDomains.length > 0 && (
                        <div
                            className="ml-2 bg-muted hover:bg-muted/80 rounded-full p-0.5 transition-colors cursor-pointer"
                            onClick={clearFilter}
                        >
                            <X className="h-3 w-3" />
                        </div>
                    )}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[320px] p-0" align="start">
                <div className="p-2 border-b bg-muted/20">
                    <p className="text-xs font-medium text-muted-foreground px-2 py-1">
                        Pilih domain. Urutan klik menentukan posisi di tabel.
                    </p>
                </div>
                <div className="max-h-[300px] overflow-y-auto p-1 scrollbar-thin">
                    {domains.map((domain) => {
                        const isSelected = selectedDomains.includes(domain);
                        const selectedIndex = selectedDomains.indexOf(domain);

                        return (
                            <div
                                key={domain}
                                className={cn(
                                    "flex items-center justify-between px-2 py-2 text-xs rounded-sm cursor-pointer hover:bg-accent transition-colors",
                                    isSelected && "bg-accent/50 text-accent-foreground font-medium"
                                )}
                                onClick={() => toggleDomain(domain)}
                            >
                                <span className="truncate pr-2">{domain}</span>
                                {isSelected && (
                                    <Badge variant="default" className="h-5 min-w-5 flex items-center justify-center px-1 text-[10px] bg-primary">
                                        {selectedIndex + 1}
                                    </Badge>
                                )}
                            </div>
                        );
                    })}
                    {domains.length === 0 && (
                        <div className="text-center py-4 text-xs text-muted-foreground">
                            Tidak ada domain tersedia
                        </div>
                    )}
                </div>
            </PopoverContent>
        </Popover>
    );
}
